var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "comments-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "i-chat",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9988405,6.00070001 C8.92478661,6.00070001 4,9.83737675 4,14.5717714 C4,17.5198304 5.68125048,20.0900818 8.59033211,21.6340127 C8.59033211,21.650013 8.58363212,21.6650133 8.58363212,21.6830137 C8.58363212,22.9657393 7.89452216,24.3720674 7.48823777,25.0973819 L7.48823777,25.0973819 C7.45681781,25.1773835 7.43660785,25.2605852 7.43660785,25.351587 C7.43660785,25.7107942 7.71494543,26 8.06062391,26 C8.11225383,26 8.19530371,25.9879998 8.22672866,25.9879998 C8.23342865,25.9879998 8.23799864,25.9879998 8.23799864,25.9879998 C10.3861394,25.6241925 12.7475219,23.651153 13.2189002,23.0563411 C13.7015024,23.1313426 14.029224,23.1423428 14.4310184,23.1423428 C14.6016121,23.1423428 14.7856758,23.1423428 15.0011625,23.1423428 C21.0752134,23.1423428 26,19.3056661 26,14.5710714 C25.9978,9.83667673 21.0729684,6 14.9989145,6 L14.9988405,6.00070001 Z M14.673364,21.7156143 L14.4286964,21.7156143 C14.0515929,21.7156143 13.8046803,21.7056141 13.4185989,21.6456129 L12.646434,21.5313106 L12.1526098,22.1541231 C11.9236541,22.4409288 10.7654099,23.4298486 9.48595177,24.0665613 C9.74408838,23.350647 9.93712809,22.5715314 9.95508607,21.7973159 L9.96178606,20.7546951 L9.21206918,20.3582872 C6.77212284,19.0591612 5.37369794,16.950819 5.37369794,14.5695714 C5.37369794,10.6326927 9.69242746,7.42822856 14.9965605,7.42822856 C20.3029415,7.42822856 24.6194251,10.6326927 24.6194251,14.5695714 C24.6216251,18.5064501 20.3051855,21.7110142 14.9988055,21.7110142 L14.673364,21.7156143 Z",
    id: "path4294",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.f36f158fa5a408d85d4ee1ad3a7e74ce.svg";
export { ForwardRef as ReactComponent };